import { safeDeleteSheet } from "@/lib/office-helpers";

export async function startProject3(): Promise<void> {
  await Excel.run(async (ctx) => {
    // ═══ HOJA 1 – Inscripciones Escuela de Esquí ═══
    const nombreHoja = "Inscripciones Escuela de Esquí";
    await safeDeleteSheet(ctx, nombreHoja);
    const sh = ctx.workbook.worksheets.add(nombreHoja);

    const filas2 = [
      ["Nombre", "Nivel", "Tamaño de la clase"],
      ["Blue Jay", "I", ""],
      ["Chipmunk", "II", ""],
      ["Snowbuck", "III", ""],
      ["Badger", "IV", ""],
      ["Bobcat", "V", ""],
      ["Osprey", "VI", ""],
      ["Wolverine", "VII", ""],
      ["Grizzly*", "VIII", ""],
      ["Cougar*", "IX", ""],
      ["Eagle*", "X", ""],
    ];
    sh.getRangeByIndexes(4, 0, filas2.length, 3).values = filas2;

    sh.getRange("E6:E9").values = [[5], [6], [7], [8]];

    // Título
    sh.getRange("A4:E4").merge();
    sh.getRange("A4").values = [["Inscripciones en la Escuela de Esquí"]];
    sh.getRange("A4").format.set({
      horizontalAlignment: "Center",
      font: { bold: true, size: 16 },
    });

    // Nota
    sh.getRange("A17").values = [
      [
        "* El tamaño de la clase debe ser un mínimo de 3 y un máximo de 10 estudiantes.",
      ],
    ];
    sh.getRange("A17:G17").merge();

    // Estilo tabla
    const tabla = sh.getRange("A5:C15");
    tabla.format.fill.color = "#d9e6fb";
    (
      [
        "EdgeTop",
        "EdgeBottom",
        "EdgeLeft",
        "EdgeRight",
        "InsideHorizontal",
        "InsideVertical",
      ] as const
    ).forEach((id) => {
      const b = tabla.format.borders.getItem(id);
      b.style = "Continuous";
      b.weight = "Thin";
      b.color = "#000000";
    });

    sh.getUsedRange().format.autofitColumns();
    sh.activate();

    // ═══ HOJA 2 – Precios de Esquí en Utah ═══
    const nombreHoja2 = "Precios de Esquí en Utah";
    await safeDeleteSheet(ctx, nombreHoja2);
    const sh2 = ctx.workbook.worksheets.add(nombreHoja2);

    const filas = [
      [
        "ID #",
        "Complejos de esquí",
        "Pase de un día para adultos\n(US $)",
        "Pase de un día para niños\n(US $)",
        "Pase anual de adultos\n(US $)",
        "Pase anual de niños\n(US $)",
        "Promedio. Pulgadas de nieve anuales",
        "Hectáreas esquiables",
        "Número de ascensores",
        "Número de carreras",
      ],
      [1, "Alta Ski Area", 75, 40, 1199, 199, 563, 2200, 11, 116],
      [2, "Beaver Mountain", 45, 35, 535, 320, 400, 828, 5, 47],
      [3, "Brian Head", 49, 35, 539, 239, 370, 665, 9, 71],
      [4, "Brighton", 68, 35, 899, 199, 500, 1050, 5, 66],
      [5, "Canyons", 107, 69, 529, 269, 355, 4000, 16, 182],
      [6, "Deer Valley", 108, 68, 1910, 480, 300, 2026, 21, 100],
      [7, "Eagle Point", 48, 25, 399, 229, 450, 625, 6, 40],
      [
        8,
        "Park City Mountain Resort",
        107,
        69,
        880,
        205,
        365,
        3300,
        16,
        144,
      ],
      [9, "Powder Mountain", 65, 35, 895, 250, 500, 2800, 7, 135],
      [10, "Snowbasin", 82, 44, 899, 249, 400, 3000, 10, 113],
      [11, "Snowbird", 92, 45, 1199, 438, 500, 2500, 17, 89],
      [12, "Solitude", 74, 46, 799, 549, 500, 1200, 7, 65],
      [13, "Sundance", 54, 32, 485, 265, 300, 450, 5, 42],
      [14, "Wolf Mountain", 32, 20, 305, 215, 300, 110, 4, 22],
    ];
    sh2.getRangeByIndexes(1, 0, filas.length, filas[0].length).values = filas;

    // Título
    sh2.getRange("A1:J1").merge();
    sh2.getRange("A1").values = [["Estaciones de esquí de Utah 2014"]];
    sh2.getRange("A1").format.set({
      horizontalAlignment: "Center",
      font: { bold: true, size: 16 },
    });

    // Tabla visual
    const rangoTabla = sh2.getRange("A2:J16");
    rangoTabla.format.fill.color = "#d9e6fb";
    rangoTabla.format.font.bold = false;
    sh2.getRange("A2:J2").format.font.bold = true;

    (
      [
        "EdgeTop",
        "EdgeBottom",
        "EdgeLeft",
        "EdgeRight",
        "InsideHorizontal",
        "InsideVertical",
      ] as const
    ).forEach((id) => {
      const b = rangoTabla.format.borders.getItem(id);
      b.style = "Continuous";
      b.weight = "Thin";
      b.color = "#000000";
    });

    // Formato moneda
    (["C", "D", "E", "F"] as const).forEach((col) => {
      sh2.getRange(`${col}3:${col}16`).numberFormat = [["$#,##0.00"]];
    });
    (["G", "H", "I", "J"] as const).forEach((col) => {
      sh2.getRange(`${col}3:${col}16`).numberFormat = [["#,##0"]];
    });

    // Wrap text en encabezados
    sh2.getRange("C2:J2").format.wrapText = true;
    sh2.getRange("C2:J2").format.autofitRows();
    sh2.getRange("C2:J2").format.set({
      horizontalAlignment: "Center",
      verticalAlignment: "Center",
    });

    // Panel "Precio medio…"
    sh2.getRange("L2:M2").merge();
    sh2.getRange("L2").values = [
      [
        'Precio medio en los complejos grandes\n(>2,000 hectáreas y >15 ascensores)',
      ],
    ];
    sh2.getRange("L2").format.set({
      horizontalAlignment: "Center",
      verticalAlignment: "Center",
      font: { bold: true },
      fill: { color: "#d9e6fb" },
    });
    sh2.getRange("M3").values = [["Pase anual de adulto (US $)"]];
    sh2.getRange("M4").values = [["Pase anual de niño (US $)"]];

    const box1 = sh2.getRange("L2:M4");
    (
      [
        "EdgeTop",
        "EdgeBottom",
        "EdgeLeft",
        "EdgeRight",
        "InsideHorizontal",
        "InsideVertical",
      ] as const
    ).forEach((id) => {
      const b = box1.format.borders.getItem(id);
      b.style = "Continuous";
      b.weight = "Thin";
      b.color = "#000000";
    });

    // Panel "Sumar el total…"
    sh2.getRange("O2:Q2").merge();
    sh2.getRange("O2").values = [
      [
        "Sumar el Total de Pases Anuales de Adultos para\nComplejos con Más de 400 Pulgadas de Nieve y Más\nde 1000 Hectáreas Esquiables",
      ],
    ];
    sh2.getRange("O2").format.set({
      horizontalAlignment: "Center",
      verticalAlignment: "Center",
      font: { bold: true },
      fill: { color: "#d9e6fb" },
    });
    sh2.getRange("P3").values = [["Pase anual de adulto (US $)"]];

    const box2 = sh2.getRange("O2:Q3");
    (
      [
        "EdgeTop",
        "EdgeBottom",
        "EdgeLeft",
        "EdgeRight",
        "InsideHorizontal",
        "InsideVertical",
      ] as const
    ).forEach((id) => {
      const b = box2.format.borders.getItem(id);
      b.style = "Continuous";
      b.weight = "Thin";
      b.color = "#000000";
    });

    // Cálculo Manual
    sh2.getRange("H18:I18").merge();
    sh2.getRange("H18").values = [["Cálculo Manual"]];
    sh2.getRange("H18").format.set({
      horizontalAlignment: "Center",
      verticalAlignment: "Center",
      font: { bold: true },
      fill: { color: "#d9e6fb" },
    });
    sh2.getRange("H19").values = [[1]];
    sh2.getRange("H20").values = [[1]];
    sh2.getRange("I19").formulas = [["=SUM(H19:H20)"]];

    const box3 = sh2.getRange("H18:I20");
    (
      [
        "EdgeTop",
        "EdgeBottom",
        "EdgeLeft",
        "EdgeRight",
        "InsideHorizontal",
        "InsideVertical",
      ] as const
    ).forEach((id) => {
      const b = box3.format.borders.getItem(id);
      b.style = "Continuous";
      b.weight = "Thin";
      b.color = "#000000";
    });

    sh2.getUsedRange().format.autofitColumns();
    sh2.activate();
  });
}
